import { isViewOnlyEmbedHost } from "@/shared/domainUsers";

export function thirdPartyDomain() {
	return isViewOnlyEmbedHost(document.location.hostname);
}
